import type { QuoteFile, PresentationLibrary } from 'paintscout'
import { getLibraryFileKey } from './get-library-file-key'

/**
 * Whether a file changed directly (a drag/drop upload, or a youtube URL entry — paths that
 * don't go through PresentationLibraryDialog, which manages its own library persistence)
 * still needs to be auto-added to the library. True only for files with a library key
 * (s3/cloudinary) that isn't already present, so an already-known file — or one that can't
 * be stored in the library at all (e.g. a youtube entry) — is never re-added.
 */
export const shouldAddToLibrary = (args: { file: QuoteFile; library: PresentationLibrary }): boolean => {
  const { file, library } = args
  const libraryKey = getLibraryFileKey(file)
  return Boolean(libraryKey) && !library?.order?.includes(libraryKey)
}
